import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actionCreateApiGateWayFactory } from '../../actions/actionCreator';

import { ACTION_KEY as API_GATEWAY_KEYS, ACTION_ATTR as API_GATEWAY_ATTRS } from '../../constants/apiGateWayConstant';

import CsvExport from '../../components/Reports/CsvExport';

function mapStateToProps(state) {
  return {
    reportsData: state.csvExport.reportsData,
  };
}

const mapDispatchToProps = dispatch => ({
  actions: {
    getReportsData: bindActionCreators(actionCreateApiGateWayFactory(API_GATEWAY_KEYS.GET_REPORTS_DATA, API_GATEWAY_ATTRS.PAYLOAD), dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CsvExport);



// WEBPACK FOOTER //
// ./src/Containers/Reports/CsvExportDetails.js